import { OptionCDT } from '../../Utils/selectOptions';
import { client } from '../client';
import { UserRoleName } from './types/UserProfile';

export const listCDTOptions = async (userRole?: string): Promise<OptionCDT[]> => {
  const prefix = userRole === UserRoleName.Collector ? '/collector' : '';
  const { data } = await client.get(`${prefix}/cdts`);

  return data;
};
